import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Storage from "./AuthSession";


const ProtectedRoute = ({ allowedRoles }) => {
  const userRole = Storage.getClientRole();

  if (!userRole) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
